import { render, staticRenderFns } from "./productionMonitoring.vue?vue&type=template&id=52f8bde6&scoped=true&"
import script from "./productionMonitoring.vue?vue&type=script&lang=js&"
export * from "./productionMonitoring.vue?vue&type=script&lang=js&"
import style0 from "./productionMonitoring.vue?vue&type=style&index=0&id=52f8bde6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f8bde6",
  null
  
)

export default component.exports